const formActions = require('react-redux-form').actions;
const actionTypes = require('constants/actionTypes');
import { history } from 'routes/history';
const {
    IBAN_TRANSFER_OTP_RETRY_OTP,
    IBAN_TRANSFER_OTP_SEND_OTP,
    IBAN_TRANSFER_OTP_VALIDATE,
} = require('constants/identityMethod');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
const { BASE_PATH } = require('constants/index');
const { CREDIT_CARD, TRADITIONAL } = require('constants/userProfile');

const showIban = (dispatch, data) => {
    dispatch(formActions.change('userProfile.showIban', data));
};

const toggleShowIban = data => {
    return dispatch => showIban(dispatch, data);
};

const resetIban = () => {
    return dispatch => {
        dispatch(formActions.change('userProfile.ibanTermsClause', false));
        dispatch(formActions.change('userProfile.iban', ''));
        dispatch(formActions.change('userProfile.identityIban', ''));
        dispatch({ type: actionTypes.OKIBAN_INTERNAL_RESET });

        setTimeout(() => {
            dispatch({ type: actionTypes.OKIBAN_RESET });
        }, 150);
    };
};

const resetIdentityIban = () => {
    return dispatch => {
        dispatch(formActions.change('userProfile.ibanTermsClause', undefined));
        dispatch(formActions.change('userProfile.identityIban', ''));
        dispatch({ type: actionTypes.OKIBAN_INTERNAL_RESET });

        setTimeout(() => {
            dispatch({ type: actionTypes.OKIBAN_RESET });
        }, 150);
    };
};

const setIbanError = error => {
    return dispatch => dispatch({ type: actionTypes.OKIBAN_ERROR, data: error });
};

const checkUserStatus = async accessToken => {
    try {
        const requestParams = {
            header: { Authorization: 'Bearer ' + accessToken },
        };

        const response = await Api.get(apiURLBuilder.getURL('checkUserStatus'), requestParams);
        if (response.ok) return response.body;
    } catch (error) {
        throw new Error(error);
    }
};

const changeUserStatusCall = (accessToken, type = 'CHANGE_STATUS') => {
    const TYPE_CALL = {
        RETURN_STATUS: async () => {
            return await checkUserStatus(accessToken);
        },
        CHANGE_STATUS: async dispatch => {
            const response = await checkUserStatus(accessToken);
            dispatch(formActions.change('userProfile.status', response.status));
        },
    };

    return async dispatch => await TYPE_CALL[type](dispatch);
};

const ibanTransferOTPPostRequest = async (accessToken, endpoint, data) => {
    const OTP_REQUESTS_TYPES = {
        [IBAN_TRANSFER_OTP_SEND_OTP]: 'creditCardIbanTransferOtpSend',
        [IBAN_TRANSFER_OTP_RETRY_OTP]: 'creditCardIbanTransferOtpRetry',
        [IBAN_TRANSFER_OTP_VALIDATE]: 'creditCardIbanTransferOtpValidate',
    };

    try {
        const requestParams = {
            header: { Authorization: 'Bearer ' + accessToken },
            query: data,
        };

        const response = await Api.post(apiURLBuilder.getURL(OTP_REQUESTS_TYPES[endpoint]), requestParams);
        if (response.ok) return response.body;
    } catch (error) {
        if (error.body.error === '2301') {
            return { status: 'EXPIRED_RETRY' };
        }
        history.push(BASE_PATH + '/errors');
    }
};

const ibanTransferOTPGetRequest = async accessToken => {
    try {
        const requestParams = {
            header: { Authorization: 'Bearer ' + accessToken },
        };

        const response = await Api.get(apiURLBuilder.getURL('creditCardIbanTransferOtpStatus'), requestParams);
        if (response.ok) return response.body;
    } catch (error) {
        history.push(BASE_PATH + '/errors');
    }
};

const ibanTransferOTPCall = (accessToken, type, endpoint = '', data = {}) => {
    const OTP_CALL_TYPES = {
        ['GET']: ibanTransferOTPGetRequest,
        ['POST']: ibanTransferOTPPostRequest,
    };

    return async dispatch => {
        return await OTP_CALL_TYPES[type](accessToken, endpoint, data);
    };
};

const ibanValidationRequest = async (dispatch, accessToken, iban, endppoint) => {
    const requestParams = {
        header: { Authorization: 'Bearer ' + accessToken },
        query: { iban },
    };

    const response = await Api.post(apiURLBuilder.getURL(endppoint), requestParams);
    if (response.ok) return response.body;
};

const ibanValidationActionCall = (accessToken, iban, type = TRADITIONAL) => {
    return async dispatch => {
        const IBAN_VALIDATION_ENDPOINTS_BY_TYPE = {
            [CREDIT_CARD]: 'creditCardIbanVerify',
            [TRADITIONAL]: 'ibanIberpayVerify',
        };

        const endpoint = IBAN_VALIDATION_ENDPOINTS_BY_TYPE[type]
            ? IBAN_VALIDATION_ENDPOINTS_BY_TYPE[type]
            : IBAN_VALIDATION_ENDPOINTS_BY_TYPE[TRADITIONAL];

        try {
            const response = await ibanValidationRequest(dispatch, accessToken, iban, endpoint);
            const RESPONSES = {
                OK: () => 'OK',
                KO: () => dispatch({ type: actionTypes.OKIBAN_ERROR, data: '' }),
                SUCCESS: () => 'OK',
            };
            return {
                status: RESPONSES[response.status] ? RESPONSES[response.status]() : RESPONSES['KO'](),
                bank: response.bank,
            };
        } catch (error) {
            return { status: 'OK' };
        }
    };
};

export default {
    toggleShowIban,
    resetIban,
    setIbanError,
    ibanTransferOTPGetRequest,
    changeUserStatusCall,
    ibanTransferOTPCall,
    ibanValidationActionCall,
    resetIdentityIban,
};
